import { Turbo } from "@hotwired/turbo-rails";
import * as ActionCable from "@rails/actioncable/src";
import Cookies from "js-cookie";
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

import "../datadog";
import "../custom_turbo_stream_actions";

import Rails from "@rails/ujs";
window.Rails = Rails;
window.Rails.start();

ActionCable.logger.enabled = !!window.RINSED_ACTION_CABLE_DEBUG;

// Disable Turbo Drive by default. Enable via `data-turbo="true"`.
Turbo.session.drive = false;

window.Stimulus = Application.start();

// Auto-discover and register all Stimulus controllers from app/javascript/controllers/
// using webpack's require.context, so we don't have to manually import each one.
const context = require.context("../controllers", true, /\.js$/);
Stimulus.load(definitionsFromContext(context));

Cookies.remove("timezone");
Cookies.set("timezone", encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone));
